import { useState } from "react";
import { useMessageContext } from "../context/messageContext";

export const useMessageControllers = () => {
  const [showAddChat, setShowAddChat] = useState(false)

  const handleShowAddChat = () => setShowAddChat((prev) => !prev)


  const { chatType, setChatType } = useMessageContext();
  const chatOptions = [
    { label: "All Conversations", onClick: () => setChatType("All Conversations") },
    { label: "Company", onClick: () => setChatType("Company") },
    { label: "Customers", onClick: () => setChatType("Customers") },
    // { label: "Users", onClick: () => setChatType("Users") },
  ];


  return {
    // state
    chatType,
    showAddChat,
    // data
    chatOptions,
    // function
    handleShowAddChat
  };
};
